import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
// import { getInOutsEmployeeList, createEmployeeTimbratura, deleteEmployeeTimbratura, updateEmployeeTimbratura } from '../services/api_timbrature';
import { getTimbrature } from "../../services/api_dipendenti";
import { PencilSquareIcon, TrashIcon, GlobeEuropeAfricaIcon } from "@heroicons/react/24/outline";
import { MapPinIcon } from '@heroicons/react/24/solid';
import Swal from "sweetalert2";
import moment from "moment";
import LocationModal from '../../components/location_modal';
import Empty from '../../components/empty';
import { Popover } from '@headlessui/react';
import Fetching from "../../components/fetching";




const mesiInItaliano = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
]


export default function TimbraturaCalendar() {
  const { token } = useContext(AuthContext);
  const [timbrature, setTimbrature] = useState({});
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [timbraturaTimeCheckIn, setTimbraturaTimeChecKIn] = useState('');
  const [timbraturaTimeCheckOut, setTimbraturaTimeChecKOut] = useState('');
  const [selectedTimbratura, setSelectedTimbratura] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [weekInfo, setWeekInfo] = useState({});
  

  // const fetchData = async (selectedDay = day) => {
  //   const startOfMonth = moment(selectedDay).startOf('month').format('YYYY-MM-DD');
  //   const endOfMonth = moment(selectedDay).endOf('month').format('YYYY-MM-DD');
  
  //   setLoading(true);
  //   try {
  //     const response = await getTimbrature(
  //       token,
  //       startOfMonth,
  //       1,
  //       100,
  //       endOfMonth
  //     );
  
  //     const mappedTimbrature = response.results.reduce((acc, record) => {
  //       const date = moment(record.checkin).format('YYYY-MM-DD');
  //       if (!acc[date]) {
  //         acc[date] = [];
  //       }
  //       acc[date].push(record);
  //       return acc;
  //     }, {});
  
  //     setTimbrature(mappedTimbrature);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Errore nel recupero delle timbrature:', error);
  //     setLoading(false);
  //   }
  // };  


  const fetchData = async (realday = day) => {
    const startOfMonth = moment(realday).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(realday).endOf('month').format('YYYY-MM-DD');
  
    setWeekInfo({ startOfMonth, endOfMonth });
    setLoading(true);
  
    try {
      const shiftsResponse = await getTimbrature(token, { start: startOfMonth, end: endOfMonth });     
  
      const mappedTimbrature = shiftsResponse.results.reduce((acc, record) => {
        const date = moment(record.checkin).format('YYYY-MM-DD');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(record);
        return acc;
      }, {});
  
      setTimbrature(mappedTimbrature);
      setLoading(false);
    } catch (error) {
      console.error('Errore nel recupero delle timbrature:', error);
      setLoading(false);
    }
  }; 

  useEffect(() => {
    fetchData();
  }, [day]);

  const nextMonth = () => {
    setDay(moment(day).add(1, 'month').toDate());
  };

  const prevMonth = () => {
    setDay(moment(day).subtract(1, 'month').toDate());
  };

  const setOggi = () => {
    setDay(new Date());
  };

  const openModal = (date) => {
    setSelectedDate(date);
    setShowModal(true);
  };
  

  
  
  
  return (
    <div>
      <Popover as="header" className={`bg-indigo-200`}>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                <h2 className="text-center text-2xl font-semibold text-indigo-800">Le mie timbrature</h2>
              </div>
            </div>
          </div>
        </div>
      </Popover>

      {loading && <Fetching />}

      {/* {!loading && timbrature && !timbrature?.active_contract  && (
        <div
          className="m-4 relative block rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          <div role="status">
            <span className="sr-only">Nessun dato</span>
          </div>
          <span className="mt-2 block text-sm font-semibold text-gray-900">Non hai un contratto attivo</span>
        </div>
      )} */}
   
      <div>
        {loading && <p>Caricamento...</p>}
          <div className="px-4 sm:px-6 lg:px-8 mt-5">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-base font-semibold leading-6 text-gray-900">Timbrature di {mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY') }</h1>
                <p className="mt-2 text-sm text-gray-700">
                  Qui puoi vedere le timbrature per il mese selezionato
                </p>
                <div className="relative flex items-center rounded-md bg-white md:items-stretch mt-3">
                  <button onClick={prevMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50">
                    <span className="sr-only">Mese Precedente</span>
                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd"></path>
                    </svg>
                  </button>
                  <button onClick={setOggi}
                  type="button" className="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block">{mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY') }</button>
                  <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden"></span>
                  <button onClick={nextMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50">
                    <span className="sr-only">Mese Successivo</span>
                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {!(!loading && (!timbrature || Object.keys(timbrature).length === 0)) && (
              <Calendar 
                day={day} 
                timbrature={timbrature} 
                openModal={openModal} 
              />
            )}
            {(!loading && (!timbrature || Object.keys(timbrature).length === 0)) && (
              <Empty />
            )}
          </div>
        </div>   
    </div>
  );
}

const Calendar = ({ day, timbrature, openModal }) => {
  const [isModalLocationOpen, setIsModalLocationOpen] = useState(false);
  const [modalLocations, setModalLocations] = useState([]);

  const getDayOfWeek = (dateString) => {
    const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
    return days[new Date(dateString).getDay()];
  };

  const getDaysOfMonth = (date) => {
    const startOfMonth = moment(date).startOf('month');
    const endOfMonth = moment(date).endOf('month');
    const days = [];
    let currentDay = startOfMonth;

    while (currentDay.isSameOrBefore(endOfMonth)) {
      days.push(currentDay.clone());
      currentDay = currentDay.add(1, 'day');
    }
    return days;
  };

  const daysInMonth = getDaysOfMonth(day);

  const handleOpenMap = (locations) => {
    if (locations.length === 0) {
      setModalLocations(null);
    } else {
      setModalLocations(locations);
    }
    setIsModalLocationOpen(true);
  };

  const handleCloseMap = () => {
    setIsModalLocationOpen(false);
    setModalLocations([]);
  };


  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col">
        {daysInMonth.map((currentDay) => {
          const dateKey = currentDay.format('YYYY-MM-DD');
          const dayTimbrature = timbrature[dateKey] || [];

          return (
          <div key={currentDay.format('YYYY-MM-DD')} className="flex items-center border-b border-gray-300 py-2">
            <div className="w-1/6 pe-4">
              <div>
                <div className="text-lg font-semibold">{currentDay.format('DD')}</div>
                <div className="text-sm text-gray-500">{getDayOfWeek(currentDay.format('YYYY-MM-DD'))}</div>
              </div>
            </div>
            <div className="w-5/6 flex flex-col">
              {timbrature[currentDay.format('YYYY-MM-DD')] ? (
                timbrature[currentDay.format('YYYY-MM-DD')]
                  .sort((a, b) => {
                    const checkinA = moment(a.checkin);
                    const checkinB = moment(b.checkin);
                    return checkinA.isBefore(checkinB) ? -1 : 1;
                  })
                  .map((timbratura, index) => {
                    const locations = [];
                    if (timbratura.checkin_lat && timbratura.checkin_lng) {
                      locations.push({
                        latitude: timbratura.checkin_lat,
                        longitude: timbratura.checkin_lng,
                        accuracy: timbratura.checkin_accuracy || 50,
                        type: 'checkin',
                      });
                    }
                    if (timbratura.checkout_lat && timbratura.checkout_lng) {
                      locations.push({
                        latitude: timbratura.checkout_lat,
                        longitude: timbratura.checkout_lng,
                        accuracy: timbratura.checkout_accuracy || 50,
                        type: 'checkout',
                      });
                    }
                    return (
                    <div key={index} className="flex items-center justify-between bg-white border rounded-md p-2 mb-2">
                      <div className="text-sm">
                        <span className="font-semibold">Entrata</span> {timbratura.checkin ? moment(timbratura.checkin).format('HH:mm') : ''} <br />
                        <span className="font-semibold">Uscita</span> {timbratura.checkout ? moment(timbratura.checkout).format('HH:mm') : ''} <br />
                        <span className="font-semibold align-items me-1">Posizione Timbratura </span>
                        <MapPinIcon
                          className="inline-block h-5 w-5 mb-1 cursor-pointer text-indigo-600"
                          onClick={() => handleOpenMap(locations)}
                        />
                        <br />
                      </div>
                    </div>
                  )})
              ) : (
                <div className="text-sm text-gray-500">Nessuna registrazione</div>
              )}
            </div>
          </div>
          );}

        )}
        {isModalLocationOpen && (
          <LocationModal
            isOpen={isModalLocationOpen}
            onClose={handleCloseMap}
            locations={modalLocations}
          />
        )}
      </div>
    </div>
  );
};


